import React, { useEffect, useRef, useState } from 'react';
import prefersReducedMotion from './prefersReducedMotion';

/** Counts a number up when scrolled into view. Renders `fallback` while `to` is null. */
export default function CountUp({ to, prefix = '', suffix = '', duration = 1600, className = '', fallback = '—' }) {
  const ref = useRef(null);
  const [val, setVal] = useState(to ?? 0);
  useEffect(() => {
    if (to == null) return undefined;
    const el = ref.current;
    setVal(to);
    if (!el || prefersReducedMotion() || typeof IntersectionObserver === 'undefined') return undefined;
    setVal(0);
    let raf = 0;
    const io = new IntersectionObserver(
      ([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now();
        const step = (now) => {
          const p = Math.min(1, (now - t0) / duration);
          setVal(to * (1 - Math.pow(1 - p, 4)));
          if (p < 1) raf = requestAnimationFrame(step);
        };
        raf = requestAnimationFrame(step);
      },
      { threshold: 0.5 },
    );
    io.observe(el);
    return () => { io.disconnect(); cancelAnimationFrame(raf); };
  }, [to, duration]);
  return (
    <span ref={ref} className={`pnp-num ${className}`.trim()}>
      {to == null ? fallback : `${prefix}${Math.round(val).toLocaleString('en-US')}${suffix}`}
    </span>
  );
}
